import { render, staticRenderFns } from "./channelMatrix.vue?vue&type=template&id=2c320228&scoped=true"
import script from "./channelMatrix.vue?vue&type=script&lang=js"
export * from "./channelMatrix.vue?vue&type=script&lang=js"
import style0 from "./channelMatrix.vue?vue&type=style&index=0&id=2c320228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c320228",
  null
  
)

export default component.exports